import React from 'react';
import './style.css';
type Props = {
	strength: string;
};
const PasswordMeter = ({ strength }: Props) => {
	switch (strength) {
		case 'Too weak':
			return (
				<>
					<div className="d-flex align-items-center mb-3">
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary rounded h-5px"></div>
					</div>
				</>
			);
		case 'Weak':
			return (
				<>
					<div className="d-flex align-items-center mb-3">
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary rounded h-5px"></div>
					</div>
				</>
			);
		case 'Medium':
			return (
				<>
					<div className="d-flex align-items-center mb-3">
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary rounded h-5px"></div>
					</div>
				</>
			);
		case 'Strong':
			return (
				<>
					<div className="d-flex align-items-center mb-3">
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-custom-password-meter rounded h-5px me-2"></div>
					</div>
				</>
			);
		default:
			return (
				<>
					<div className="d-flex align-items-center mb-3">
						<div className="flex-grow-1 bg-secondary bg-active-too-weak rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-weak rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-medium rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-strong rounded h-5px"></div>
					</div>
				</>
			);
	}
};

export default PasswordMeter;
